// @flow

export default function resolveRadioWithOther(value: mixed): string {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (
    typeof value === 'object' &&
    value.other &&
    typeof value.other === 'string'
  ) {
    return value.other;
  }

  return String(value);
}
